"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Boolean = void 0;
const IonTypes_1 = require("../IonTypes");
const FromJsConstructor_1 = require("./FromJsConstructor");
const NativeJsTypes_1 = require("./NativeJsTypes");
const Value_1 = require("./Value");
const _fromJsConstructor = new FromJsConstructor_1.FromJsConstructorBuilder()
    .withPrimitives(FromJsConstructor_1.Primitives.Boolean)
    .withClassesToUnbox(NativeJsTypes_1._NativeJsBoolean)
    .build();
/**
 * Represents a boolean[1] value in an Ion stream.
 *
 * Because this class extends Javascript's (big-B) Boolean data type, it is subject to the same
 * surprising behavior when used for control flow.
 *
 * From the Mozilla Developer Network documentation[2]:
 *
 * > Any object of which the value is not undefined or null, including a Boolean object
 *   whose value is false, evaluates to true when passed to a conditional statement.
 *
 *      var b = false;
 *      if (b) {
 *          // this code will NOT be executed
 *      }
 *
 *      b = new Boolean(false);
 *      if (b) {
 *          // this code WILL be executed
 *      }
 *
 * [1] http://amzn.github.io/ion-docs/docs/spec.html#bool
 * [2] https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean#Description
 */
class Boolean extends (0, Value_1.Value)(NativeJsTypes_1._NativeJsBoolean, IonTypes_1.IonTypes.BOOL, _fromJsConstructor) {
    /**
     * Constructor.
     * @param value         The boolean value of the new instance.
     * @param annotations   An optional array of strings to associate with `value`.
     */
    constructor(value, annotations = []) {
        super(value);
        this._setAnnotations(annotations);
    }
    booleanValue() {
        return this.valueOf();
    }
    writeTo(writer) {
        writer.setAnnotations(this.getAnnotations());
        writer.writeBoolean(this.booleanValue());
    }
    _valueEquals(other, options = {
        epsilon: null,
        ignoreAnnotations: false,
        ignoreTimestampPrecision: false,
        onlyCompareIon: true,
    }) {
        let isSupportedType = false;
        let valueToCompare = null;
        // if the provided value is an ion.dom.Boolean instance.
        if (other instanceof Boolean) {
            isSupportedType = true;
            valueToCompare = other.booleanValue();
        }
        else if (!options.onlyCompareIon) {
            // We will consider other Boolean-ish types
            if (typeof other === "boolean" || other instanceof NativeJsTypes_1._NativeJsBoolean) {
                isSupportedType = true;
                valueToCompare = other.valueOf();
            }
        }
        if (!isSupportedType) {
            return false;
        }
        if (this.booleanValue() !== valueToCompare) {
            return false;
        }
        return true;
    }
}
exports.Boolean = Boolean;
